import React, { useEffect } from "react";
import { Button, Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as cartSlice from "../../../../redux/slices/cartSlice"; // Import the cartSlice

const PaymentDetails = ({ selectedCart }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const paymentData = location.state.paymentData;
  const { cartDetails } = useSelector((state) => state.cartSlice); // Updated to cartSlice
  console.log(paymentData, "paymentData");
  return (
    <div className="">
      <div className="text-left mt-4">
        <Button
          style={{ backgroundColor: "#e8783d", border: "none" }}
          onClick={() => navigate(-1)} // Go back to the previous page
        >
          Back
        </Button>
      </div>
      <h1 className="text-center">Payment Details</h1>
      <Row className="g-3">
        {/* User Details */}
        <h5>Payment Details:</h5>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Payment Id:</strong>{" "}
            {paymentData?.razorpay_payment_id || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Amount:</strong> {paymentData?.amount || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Currency:</strong> {paymentData?.currency || "-"}
          </p>
        </Col>{" "}
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Status:</strong> {paymentData?.status || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Payment Date:</strong>{" "}
            {paymentData?.created_at
              ? moment(paymentData.created_at).format("DD-MM-YY")
              : "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Customize Trip Name:</strong>{" "}
            <a
              href={`/customize-cart/${
                paymentData?.customized_package?.id || "#"
              }`}
              style={{ color: "#007bff", textDecoration: "underline" }}
            >
              {paymentData?.customized_package?.trip_name || "-"}
            </a>
          </p>
        </Col>
        <hr /> {/* Trip Details */}
        <h5>User Details:</h5>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Name:</strong> {paymentData?.user?.first_name || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Email:</strong> {paymentData?.user?.email || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Mobile Number:</strong>{" "}
            {paymentData?.user?.mobile_no || "-"}
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentDetails;
